import React from 'react';
import '../index.css';
import Intro from '../components/Index/Intro';
import ShortServices from '../components/Index/ShortServices';
import Technologies from '../components/Index/Technologies';
import Portfolio from '../components/Index/Portfolio';
import ProccessShort from '../components/Index/ProccessShort';
import WhyUs from '../components/Index/WhyUs';
import Layout from '../components/Shared/Layout';

const seo = {
  path: '/',
};

export default () => (
  <Layout seo={seo}>
    <Intro />
    <ShortServices />
    <ProccessShort />
    <Technologies />
    <WhyUs />
    <Portfolio />
  </Layout>
);
